import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'cdpWriteKey',
  initialState: null as string | null,
  reducers: {
    setCdpWriteKey(state, action) {
      return action.payload || null;
    },
  },
});

export const { setCdpWriteKey } = slice.actions;

export default slice.reducer;
